import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';

export class LunchBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: () => BenefitAttribute[] = () => [
    {
      id: 'lunchMaxNumberOfReceipts',
      accessorFn: value => value.lunchOptions?.maxNumberOfReceipts,
      header: 'LUNCH.fields.mealsPerMonth',
    },
    {
      id: 'lunchDailyLimit',
      accessorFn: value => value.lunchOptions?.dailyLimit,
      header: 'LUNCH.fields.perMeal',
      size: 100,
      renderer: value => {
        return typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null;
      },
    },
    {
      id: 'lunchMaxAmount',
      maxSize: 120,
      accessorFn: value => value.lunchOptions && value.lunchOptions!.maxNumberOfReceipts * value.lunchOptions!.dailyLimit,
      header: 'LUNCH.fields.maxAmount',
      renderer: value => {
        return typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null;
      },
    },
  ];
}
